<div class="form-tickets-lok">
    <div class="container-tickets">
        <div class="dialog-title-row" style="margin-bottom: 12px;">
            <span>Precio "Desde"</span>
            <button class="btn-close-dialog" mat-dialog-close><i class="fa-light fa-times"></i></button>
        </div>
        <mat-divider></mat-divider>

        <!-- Toggle precio personalizado -->
        <div class="section-free">
            <div class="d-flex align-items-center justify-content-between">
                <div>
                    <p class="title-free m-0">Usar precio personalizado</p>
                    <p class="m-0" style="font-size: 12px; color: var(--color-light); margin-top: 2px !important;">
                        Elige el precio que se mostrará al público como "Desde X€"
                    </p>
                </div>
                <mat-slide-toggle class="toggle-pink" [(ngModel)]="useCustomPrice" color="primary"></mat-slide-toggle>
            </div>
        </div>

        <mat-divider></mat-divider>

        <!-- Modo automático -->
        <div class="section-free" *ngIf="!useCustomPrice">
            <div class="info-send-tickets">
                <p class="m-0">
                    <i class="fa-light fa-circle-info" style="margin-right: 8px;"></i>
                    Se mostrará automáticamente el precio más bajo de entre todas las entradas activas del evento.
                </p>
            </div>
        </div>

        <!-- Modo personalizado -->
        <div class="section-free" *ngIf="useCustomPrice">
            <p class="title-free">Introduce el precio personalizado</p>
            <div class="input-price">
                <div class="input-border input-ticket">
                    <input placeholder="Ej: 12.50" type="number" min="0" [(ngModel)]="customFromPrice" />
                    <i class="fa-light fa-euro-sign"></i>
                </div>
            </div>
            <div class="info-send-tickets">
                <p class="m-0">
                    <i class="fa-light fa-circle-info" style="margin-right: 8px;"></i>
                    Este precio se mostrará en la web y en las tarjetas del evento en lugar del calculado automáticamente.
                    Útil cuando el precio mínimo real corresponde a entradas de movilidad reducida u otros casos especiales.
                </p>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-center" style="padding: 16px 25px 25px;">
        <button class="primary-button solid w-100" style="min-height: 44px;" [class.disabled]="loading" (click)="save()">
            <span *ngIf="!loading">Guardar</span>
            <span *ngIf="loading"><i class="fa-light fa-spinner fa-spin"></i></span>
        </button>
    </div>
</div>